module.exports = "<div class=\"container\">\n    <app-chat></app-chat>\n    <app-drawing-section></app-drawing-section>\n    <p> This app uses DialogFlow powered by Google. Note that what you tell the bot is saved to improve the bot.<br/> The conversation might also be used by Google for their own purpose.\n         Be careful with the informations you share with the Drawing Bot\n    </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main